const enum DCHeaderSize {
  Default = "default",
  Large = "large",
}
export default DCHeaderSize;
